import { __decorate, __metadata } from "tslib";
import { IsUndefinable, OrderPaymentInformationPhaseEnum, OrderPaymentInformationTypeEnum, PaymentMethodTypeEnum, PaymentSendStrategyEnum, PaymentSourceEnum, } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsArray, IsEnum, IsNotEmpty, IsString, MaxLength } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
export class PatchOrderPaymentInformationDto {
}
__decorate([
    ApiPropertyOptional({ enum: PaymentSendStrategyEnum, example: PaymentSendStrategyEnum.IMMEDIATE }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsEnum(PaymentSendStrategyEnum),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderPaymentInformationDto.prototype, "strategy", void 0);
__decorate([
    ApiPropertyOptional({ enum: PaymentSourceEnum, example: PaymentSourceEnum.WEB_DESKTOP }),
    IsUndefinable({ always: true }),
    IsEnum(PaymentSourceEnum),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderPaymentInformationDto.prototype, "platform", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Payment transaction Id', example: '6270f9b1ec49bb002f69909d' }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(250, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderPaymentInformationDto.prototype, "uid", void 0);
__decorate([
    ApiPropertyOptional({ enum: OrderPaymentInformationTypeEnum, example: OrderPaymentInformationTypeEnum.PREPAID }),
    IsUndefinable({ always: true }),
    IsEnum(OrderPaymentInformationTypeEnum),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderPaymentInformationDto.prototype, "type", void 0);
__decorate([
    ApiPropertyOptional({ enum: PaymentMethodTypeEnum, isArray: true, example: [PaymentMethodTypeEnum.CREDIT_CARD] }),
    IsUndefinable({ always: true }),
    IsArray({ always: true }),
    IsEnum(PaymentMethodTypeEnum, { always: true, each: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Array)
], PatchOrderPaymentInformationDto.prototype, "paidBy", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, format: 'date-time', description: 'Paid at', example: '2019-10-29T11:29:56.853+0000' }),
    IsUndefinable({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Object)
], PatchOrderPaymentInformationDto.prototype, "paidAt", void 0);
__decorate([
    ApiPropertyOptional({ enum: OrderPaymentInformationPhaseEnum, example: OrderPaymentInformationPhaseEnum.PREAUTH_DONE }),
    IsUndefinable({ always: true }),
    IsEnum(OrderPaymentInformationPhaseEnum),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderPaymentInformationDto.prototype, "phase", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Card Id', example: 'NUvuV4tfdfq2iktatuYGpcm2YsU' }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(250, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderPaymentInformationDto.prototype, "cardId", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Client ip address', example: '127.0.0.1' }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(45, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderPaymentInformationDto.prototype, "clientIpAddress", void 0);
//# sourceMappingURL=PatchOrderPaymentInformationDto.js.map